import React from 'react'
import { Register } from './router'

const LaunchModule = () => {
	const launch = require('../modules/launch')
	Register('launch', launch)
	return launch
}

const IFramePlanaltoModule = () => {
	const { SearchForm } = require('../components/trip-search-bar/search-form.component')
	const IFrameSearchForm = () => <SearchForm isIframe />
	const iframeplanalto = { ModuleRootComponent: IFrameSearchForm }
	Register('iframeplanalto', iframeplanalto)
	return iframeplanalto
}

const IntermunicipalInsuranceModule = () => {
	const intermunicipalinsurance = require('../modules/launch/intermunicipal-insurance')
	Register('intermunicipalinsurance', intermunicipalinsurance)
	return intermunicipalinsurance
}

const RegulationModule = () => {
	const regulation = require(/* webpackChunkName: "regulation" */ '../modules/regulation')
	Register('regulation', regulation)
	return regulation
}

const RebookingModule = () => {
	const rebooking = require(/* webpackChunkName: "rebooking" */ '../modules/rebooking')
	Register('rebooking', rebooking)
	return rebooking
}

const BenefitsModule = () => {
	const benfits = require(/* webpackChunkName: "benefits" */ '../modules/benefits')
	Register('benfits', benfits)
	return benfits
}

const AboutModule = () => {
	const about = require(/* webpackChunkName: "about" */ '../modules/about')
	Register('about', about)
	return about
}

const InfoModule = () => {
	const info = require(/* webpackChunkName: "info" */ '../modules/info')
	Register('info', info)
	return info
}

const AccessibilityModule = () => {
	const accessibility = require(/* webpackChunkName: "info" */ '../modules/accessibility')
	Register('accessibility', accessibility)
	return accessibility
}

const MuvicardModule = () => {
	const muvicard = require(/* webpackChunkName: "muvicard" */ '../modules/muvicard')
	Register('muvicard', muvicard)
	return muvicard
}
const MuvibusModule = () => {
	const muvibus = require(/* webpackChunkName: "muvibus" */ '../modules/muvibus')
	Register('muvibus', muvibus)
	return muvibus
}

const MuvicardRegisterModule = () => {
	const muvicardregister = require(/* webpackChunkName: "muvicardregister" */ '../modules/muvicard-register')
	Register('muvicardregister', muvicardregister)
	return muvicardregister
}

const MeuCartaoModule = () => {
	const meucartao = require(/* webpackChunkName: "meucartao" */ '../modules/meu-cartao')
	Register('meucartao', meucartao)
	return meucartao
}

const MuvicardResetPasswordModule = () => {
	const muvicardresetpassword = require(/* webpackChunkName: "muvicardresetpassword" */ '../modules/muvicard-reset-password')
	Register('muvicardresetpassword', muvicardresetpassword)
	return muvicardresetpassword
}

const MuvicardCancelModule = () => {
	const muvicardcancel = require(/* webpackChunkName: "muvicardcancel" */ '../modules/muvicard-cancel')
	Register('muvicardcancel', muvicardcancel)
	return muvicardcancel
}

const MuvicardRegulationModule = () => {
	const muvicardregulation = require(/* webpackChunkName: "muvicardregulation" */ '../modules/muvicard-regulation')
	Register('muvicardregulation', muvicardregulation)
	return muvicardregulation
}

const PolicyModule = () => {
	const policy = require(/* webpackChunkName: "policy" */ '../modules/policy')
	Register('policy', policy)
	return policy
}

const FaqModule = () => {
	const faq = require(/* webpackChunkName: "faq" */ '../modules/faq')
	Register('faq', faq)
	return faq
}

const PointsExchangeModule = () => {
	const pointsexchange = require(/* webpackChunkName: "pointsexchange" */ '../modules/points-exchange')
	Register('pointsExchange', pointsexchange)
	return pointsexchange
}

const StoreProductDetailModule = () => {
	const storeproductdetail = require(/* webpackChunkName: "storeproductdetail" */ '../modules/store-product-detail')
	Register('storeproductdetail', storeproductdetail)
	return storeproductdetail
}

const InvoiceRequestModule = () => {
	const invoicerequest = require(/* webpackChunkName: "invoicerequest" */ '../modules/invoice-request')
	Register('invoicerequest', invoicerequest)
	return invoicerequest
}

const TicketSaleModule = () => {
	const ticketsale = require(/* webpackChunkName: "ticketsale" */ '../modules/ticket-sale')
	Register('ticketsale', ticketsale)
	return ticketsale
}

const TicketModule = () => {
	const ticket = require(/* webpackChunkName: "ticket" */ '../modules/ticket')
	Register('ticket', ticket)
	return ticket
}

const SocialLoginRegisterModule = () => {
	const socialloginregister = require(/* webpackChunkName: "socialloginregister" */ '../modules/social-login')
	Register('socialloginregister', socialloginregister)
	return socialloginregister
}

export {
	FaqModule,
	LaunchModule,
	PolicyModule,
	TicketModule,
	MuvibusModule,
	MuvicardModule,
	MeuCartaoModule,
	RegulationModule,
	RebookingModule,
	BenefitsModule,
	AboutModule,
	InfoModule,
	AccessibilityModule,
	TicketSaleModule,
	PointsExchangeModule,
	IFramePlanaltoModule,
	MuvicardCancelModule,
	MuvicardRegisterModule,
	MuvicardRegulationModule,
	StoreProductDetailModule,
	InvoiceRequestModule,
	SocialLoginRegisterModule,
	MuvicardResetPasswordModule,
	IntermunicipalInsuranceModule,
}
